'use client'

import classNames from 'clsx'
import { useTranslations } from 'next-intl'

import { guestAuthHref } from '@/lib/auth/guestAuthHref'

import S from './ConnectButton.module.scss'

export default function GuestConnectBtn() {
  const t = useTranslations('header')

  return (
    <div className={S.connectWrapper}>
      <a
        href={guestAuthHref('login')}
        className={classNames(S.connectButton, S.guestConnectLink)}
      >
        <span className={S.desktopContent}>{t('menu.logIn')}</span>
        <span className={S.mobileContent}>{t('menu.logIn')}</span>
      </a>
    </div>
  )
}
